import { List, styled } from '@mui/material';
import { spaceCadet, ultraMarine } from '../../../../utils/colors';

const StyledList = styled(List)({
  margin: 0,
  fontSize: 14,
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  '& .MuiListItem-root': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: 0,
    gap: 6,
    paddingLeft: 24,
    '& .MuiListItemIcon-root': {
      color: spaceCadet[700],
      minWidth: 18,
      '& svg': {
        width: 8,
        height: 8,
      },
    },
  },
  '& .MuiTypography-body1': {
    color: ultraMarine[500],
    fontSize: 14,
    textDecoration: 'underline',
    '&:hover': {
      color: ultraMarine[700],
    },
  },

});

export default StyledList;
